import React, { useState } from "react";
import { useQuery } from "react-query";
import {
  getAllConsultations,
  getUnpaidConsultations,
} from "../../../api/index";
import ConsultationsData from "./ConsultationsData";

const AllConsultaions = () => {
  const [consultations, setConsultations] = useState([]);

  const { isLoading } = useQuery(["allConsultations"], getAllConsultations, {
    retry: 1,
    retryDelay: 500,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      const statusOrder = {
        declined: 0,
        new: 1,
        assigned: 2,
        completed: 3,
        unassigned: 4,
      };

      const paymentStatusOrder = {
        pending: 0,
        cofirmed: 1,
      };

      setConsultations(
        data?.data
          ?.filter((e) => e.paymentStatus == "confirmed")
          .sort((a, b) => statusOrder[a.status] - statusOrder[b.status])
      );
    },
  });

  return (
    <div>
      <div className="dash_title">All Consultations</div>

      <ConsultationsData consultations={consultations} loading={isLoading} />
    </div>
  );
};

export default AllConsultaions;
